<template>
  <v-select
    v-model="val"
    :dir="$dir"
    :multiple="multiple"
    label="title"
    :reduce="x => x.value"
    :options="Items"
    :clearable="clearable"
  >
    <span
      slot="no-options"
      @click="$refs.select.open = false"
    >
      {{ $t('common.noOptions') }}
    </span>
  </v-select>
</template>

<script>

import vSelect from 'vue-select'

export default {
  name: 'DietSelect',
  components: {
    vSelect,
  },
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      Items: [],
      selected: null,
      val: this.value,
    }
  },
  watch: {
    value(v) {
      this.val = v
    },
    val(v) {
      this.$emit('input', v)
    },
  },
  created() {
    this.get()
  },
  methods: {
    get() {
      this.$http.post(
        this.$api.diet.getall, {},
      )
        .then(res => {
          res.data.forEach(item => {
            this.Items.push({ title: item.Title, value: item.Id })
          })
        })
    },
  },
}
</script>
